module.exports = __webpack_public_path__ + "img/banner-TV-3__md.5f89de61.jpg";